<template>
  <div class="swiper-content">
    <div  class="swiper-wrapper" ref="swiperWrapper">
      <div class="swiper-item">
        <img class="caseimg" src="../assets/serve/1-1.png" />
      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/serve/1-2.png" />
      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/serve/1-3.png" />
      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/serve/1-4.png" />
      </div>
      <div class="swiper-item">
        <img class="caseimg" src="../assets/serve/1-5.png" />
      </div>
    </div >
    <div class="slide-wrapper">
      <div class="slide">
        <el-progress :stroke-width="3" :percentage="count" color="#E2273E" :show-text="false"></el-progress>
      </div>
      <div>
        <img @click="toLeft" class="case-icon" src="../assets/home/case-left.png"/>
        <img @click="toRight" class="case-icon" src="../assets/home/case-right.png"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 1,
      distance: 0,
      count: 33.33
    }
  },
  methods: {
    toRight() {
      if (this.distance == -66.66) return
      this.distance = this.distance - 33.33
      this.count += 33.33
      this.$refs.swiperWrapper.style.transform = `translateX(${this.distance}%)`
    },
    toLeft() {
      if (this.distance == 0) return
      this.distance = this.distance + 33.33
      this.count -= 33.33
      this.$refs.swiperWrapper.style.transform = `translateX(${this.distance}%)`
    }
  }
}

</script>
<style lang="scss" scoped>
.swiper-content {
  overflow: hidden;
  width: 100%;
}
.swiper-wrapper {
  width: 100%;
  display: flex;
  transition: transform 1s;
  .swiper-item {
    display: flex;
    padding: 0 10px;
    .caseimg {
      width: 443px;
      height: 266px;
    }
  }
}
.slide-wrapper {
  display: flex;
  align-items: center;
  padding: 0 10%;
  margin-top: 60px;
  .slide {
    flex: 1;
  }
  .case-icon {
    width: 42px;
    height: 42px;
    margin: 0 20px;
    cursor: pointer;
  }
}
</style>